<template>
  <div class="table-responsive">
    <b-table :fields="history_fields" :items="history">
      <template v-slot:cell(action)="data">
        <button class="btn p-0 btn-link" @click="openSearch(data.item)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M16.3257 14.8987L21.7057 20.2787C21.8948 20.468 22.001 20.7246 22.0009 20.9921C22.0008 21.2596 21.8945 21.5161 21.7052 21.7052C21.516 21.8943 21.2594 22.0005 20.9919 22.0004C20.7244 22.0003 20.4678 21.894 20.2787 21.7047L14.8987 16.3247C13.2905 17.5704 11.268 18.1566 9.24287 17.9641C7.21772 17.7716 5.34198 16.8148 3.99723 15.2884C2.65248 13.7619 1.93973 11.7806 2.004 9.74729C2.06826 7.71402 2.9047 5.7816 4.34315 4.34315C5.7816 2.9047 7.71402 2.06826 9.74729 2.004C11.7806 1.93973 13.7619 2.65248 15.2884 3.99723C16.8148 5.34198 17.7716 7.21772 17.9641 9.24287C18.1566 11.268 17.5704 13.2905 16.3247 14.8987H16.3257ZM10.0007 15.9997C11.592 15.9997 13.1182 15.3676 14.2434 14.2424C15.3686 13.1172 16.0007 11.591 16.0007 9.99974C16.0007 8.40845 15.3686 6.88232 14.2434 5.7571C13.1182 4.63189 11.592 3.99974 10.0007 3.99974C8.40944 3.99974 6.88332 4.63189 5.7581 5.7571C4.63289 6.88232 4.00074 8.40845 4.00074 9.99974C4.00074 11.591 4.63289 13.1172 5.7581 14.2424C6.88332 15.3676 8.40944 15.9997 10.0007 15.9997Z"
              fill="#47B2E4" />
          </svg>
        </button>
      </template>
      <template v-slot:cell(service_code)="data">
        <button class="btn p-0 btn-link">
          {{ displayServicesName(data.value) }}
        </button>
      </template>
    </b-table>
    <div class="d-flex" v-if="history.length > 0">
      <b-pagination v-model="page" :total-rows="total_count" :per-page="perpage" first-number last-number hide-ellipsis
        hide-goto-end-buttons></b-pagination>
    </div>

    <b-modal id="display_result" hide-footer :title="displayServicesName(service_code_list.join(','))" size="huge">
      <div class="text-muted text-sm position-absolute right-0" style="font-size: 12px; top: 0">
        #{{ analyse_id }}
      </div>
      <div class="d-flex">
        <div style="gap: 10px" :class="$route.name == 'cn-search-history-note' ||
            $route.name == 'business-note' ||
            $route.name == 'business-note-hist-tab' ||
            $route.name == 'bn-single'
            ? 'bt-n-group d-flex ml-auto'
            : 'ml-auto'
          ">
          <pdf v-if="$route.name !== 'short-search'" :user_id="0" :document="pdf_document" :doc_additional="pdf_parameters"
            :goods="service_code_list" :doc_id="0" source="main-service-cn" :sia_search_data_loading="sia_search_data_loading" :analyse_id="analyse_id"></pdf>
          <pdf v-if="$route.name == 'short-search'" :user_id="0" :document="pdf_document" :doc_additional="pdf_parameters" 
            :goods="service_code_list" :doc_id="0" source="short-reference-search-cn" :sia_search_data_loading="sia_search_data_loading"  :analyse_id="analyse_id">
          </pdf>
          <!-- <button v-if="$route.name=='cn-search-history-note' || $route.name=='business-note' || $route.name=='business-note-hist-tab' || $route.name=='bn-single'" @click.prevent="sendToAnalyze(analyse_id)" class="btn btn-sm btn-outline-secondary">
                    <span v-if="!sia_loading">{{$t('message.analyze')}}</span>
                    <span v-else>{{ $t('message.find_partner.services_loading') }}... {{ sia_time }}</span>
                </button> -->
        </div>
      </div>
      <div v-if="total_loaded < 3" style="position: relative; height: 100px">
        <!-- <div class="loading"></div> -->
        <!-- <div class="text-center"> {{$t('message.find_partner.load_in_progress')}}</div> -->
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
            <b-progress :value="total_loaded" :max="3" show-progress animated></b-progress>
          </div>
        </div>
        <div class="text-center">{{ timer_minutes }}:{{ timer_seconds }}</div>
        <div>
          <div class="text-center">
            {{
              $t(
                "message.find_partner.service_" +
                this.current_history_item.service_code,
              )
            }}
            {{ $t("message.find_partner.services_loading") }}
          </div>
          <div class="text-center" v-if="total_loaded == 1">
            {{ $t("message.find_partner.services_loading_data") }}
          </div>
          <div class="text-center" v-if="total_loaded == 2">
            {{ $t("message.find_partner.services_loading_translations") }}
          </div>
          <div class="text-center" v-if="total_loaded == 3">
            {{ $t("message.find_partner.services_rendering") }}
          </div>
        </div>
      </div>
      <!-- <div class="container">
            <div class="row">
                <div class="col-12"> -->

      <div class="row p-3 mx-0 mb-3 border rounded mt-3" :class="sia_loading ? 'py-5 position-relative' : ''"
        v-if="sia.complex_grade && !sia_search_data_loading">
        <div v-if="sia_loading" class="loading"></div>
        <template v-else>
          <div class="bg-light col-3 mb-3 p-3 rounded">
            <div class="text-sm text-muted mb-1">
              {{ $t("message.find_partner.common_info_Grade") }}
            </div>
            <span class="display-4 mobile-grade font-weight-bold" style="white-space: nowrap !important">{{ sia.complex_grade }}</span>
            <div>
              <small><a href="#how-is-calculated1" @click.prevent="scrollTo($event)"
                  style="text-decoration: none; border-bottom: 1px dashed">{{
                    $t("message.find_partner.common_info_as_calculated_grade")
                  }}</a></small>
            </div>
          </div>
          <div class="col-9 mb-3">
            <div class="text-sm text-muted mb-1">
              {{ $t("message.find_partner.common_info_GradeDescription") }}
            </div>
            {{ sia.description }}
          </div>
        </template>
      </div>

      <search-help-text v-if="sia.complex_grade"></search-help-text>

      <tmp-company-info-service-cn v-if="service_code_list.includes('430')"
        :data="company_info_data"></tmp-company-info-service-cn>
      <tmp-court-info-service-cn v-if="service_code_list.includes('930')"
        :data="{ response_info: court_info_data.response_info }"></tmp-court-info-service-cn>
      <tmp-company-news-service-cn v-if="service_code_list.includes('701')"
        :data="{ response_info: news_info_data.response_info }"></tmp-company-news-service-cn>
      <tmp-risk-scan-cn v-if="service_code_list.includes('736')" :data="risk_info_data"></tmp-risk-scan-cn>
      <tmp-annual-report-service-cn v-if="service_code_list.includes('213')"
        :data="annual_info_data"></tmp-annual-report-service-cn>
      <enterprise-fuzzy-service-cn v-if="service_code_list.includes('886')" :data="business_fuzzy_info"
        mode="history"></enterprise-fuzzy-service-cn>
      <enterprise-fuzzy-service-cn-410 v-if="service_code_list.includes('410') || service_code_list.includes('410_admin')" :data="business_fuzzy_info" mode="history"
        :traffic_light="traffic_light"></enterprise-fuzzy-service-cn-410>
      <short-search-results v-if="service_code_list.includes('213+736')" :data="short_search_result"
        mode="history"></short-search-results>

      <div class="row mt-4" v-if="sia.complex_grade">
        <div class="col-12" id="how-is-calculated1">
          <hr />
          <div class="text-lg font-bolder font-weight-bolder text-bolder mb-1">
            {{ $t("message.find_partner.common_info_as_calculated_grade") }}
          </div>
          {{ sia.as_calculated_grade }}
        </div>
      </div>

      <!-- </div>  
                    </div>
                </div> -->
      <div v-if="no_result" class="mt-3 text-center pb-3 alert">
        {{ $t("message.find_partner.history_results_not_found") }}
      </div>
    </b-modal>
    <b-modal size="md" id="sia_result-hist" title="Результат анализа" :hide-footer="true">
      <div id="sia_progress-hist"></div>
      <div class="sia_result_text">
        <div v-for="row in sia_result_object" class="sia-row" :id="row.key">
          <span class="title">
            {{ row.label }}
          </span>
          <span class="value" v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 280 }" :content="row.value">{{
            row.value }}</span>
          <span class="text-info text-sm" v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 280 }"
            :content="row.value"><i class="fa fa-question-circle"></i></span>
        </div>
      </div>
      <!-- <div class="sia_result_text" v-html="sia_result_text"></div> -->
    </b-modal>
  </div>
</template>
<script>
const GaugeChart = require("gauge-chart");
import ShortSearchResults from '../../../short-search/results.vue';
export default {
  name: "contragent-search-history",
  components: { ShortSearchResults },
  data() {
    return {
      short_search_result: {},
      total_count: 0,

      analyse_id: false,
      analyse_title: false,

      sia_loading: false,
      sia_search_data_loading: false,
      sia_time: "",
      sia_time_start: 0,
      sia_timer: null,
      sia_result_text: "",
      sia_result_object: [],
      sia: {},

      traffic_light: [],

      perpage: 10,
      page: 1,

      annual_info_data: {},
      risk_info_data: {},
      search_company_info_complete: false,
      anual_search_complete: false,
      risk_search_complete: false,
      court_search_complete: false,
      news_search_complete: false,
      enterprise_fuzzy_complete: false,
      no_result: false,
      court_info_data: {
        response_info: {},
      },
      news_info_data: {
        response_info: {},
      },
      business_fuzzy_info: {
        response_info: {},
        Paging: {},
      },
      company_info_data: {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      },
      total_loaded: 0,
      loading: -1,
      current_history_item: { service_code: "", log_data: {} },
      history: [],
      service_codes: [
        {
          value: "430",
          display_text: this.$t("message.find_partner.common_info_cn"),
        },
        {
          value: "930",
          display_text: this.$t("message.find_partner.court_notice_info"),
        },
        {
          value: "701",
          display_text: this.$t("message.find_partner.corporate_news_search"),
        },
        {
          value: "213",
          display_text: this.$t("message.contragent_search.annual_report"),
        },
        {
          value: "736",
          display_text: this.$t(
            "message.contragent_search.enterprise_risk_scan",
          ),
        },
        {
          value: "886",
          display_text: this.$t("message.find_partner.fuzzy_search_cn"),
        },
        {
          value: "410",
          display_text: this.$t("message.find_partner.fuzzy_search_cn"),
        },
      ],
      history_fields: [
        {
          key: "date",
          label: this.$t("message.contragent_search.date"),
          sortable: true,
        },
        {
          key: "search_text",
          label: this.$t("message.contragent_search.search_text"),
          sortable: true,
        },
        // {
        // 	key: 'service_code',
        // 	label: this.$t('message.contragent_search.service_code'),
        // 	sortable: true
        // },
        {
          key: "action",
          label: "",
          sortable: false,
        },
      ],
      timer_seconds: "00",
      timer_minutes: "00",
      interval: "",
      service_code_list: [],
      pdf_document: {},
      pdf_parameters: {},
    };
  },
  mounted() {
    console.log("user");
    console.log(this.$store.state.user);
    setTimeout(() => {
      this.load();
    }, 1000);
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "display_result") {
        this.sia_loading = false;
        clearInterval(this.sia_timer);
      }
    });
  },
  computed: {
    showSearchHelpText() {
      return this.$route.path !== '/app/short-search';
    }
  },
  methods: {
    scrollTo(event) {
      let b = document
        .querySelector("#" + event.target.href.split("#")[1])
        .getBoundingClientRect();
      document
        .querySelector("#display_result")
        .scrollTo({ top: b.y, behavior: "smooth" });
    },
    humanizeAnalyzeAPIKey(key) {
      switch (key) {
        case "high_risk":
          return "Высокий риск";
        case "plus":
          return "Плюсы";
        case "warnings":
          return "Замечания";
      }
    },
    sendToAnalyze(data) {
      this.sia_loading = true;
      this.sia_search_data_loading = true;
      this.sia_time_start = new Date().getTime() / 1000;
      this.sia_timer = setInterval(() => {
        let cur_time = new Date().getTime() / 1000;
        this.sia_time = (cur_time - this.sia_time_start).toFixed(0) + "s";
      }, 1000);
      axios
        .get(
          window.base +
          "/api/SIA_search?id=" +
          data +
          "&search_text=" +
          this.analyse_title,
        )
        .then((response) => {
          this.sia_loading = false;
          this.sia_search_data_loading = false;
          clearInterval(this.sia_timer);
          this.sia = JSON.parse(
            response.data
              .replace('"', '"')
              .replace('""', '"')
              .replace('"{', "{")
              .replace('}"', "}"),
          );
          // this.sia = JSON.parse(response.data.replace('\"', '"').replace('""', '"'))
          console.log(this.sia);
          this.pdf_document.sia = this.sia;
          this.short_search_result.sia = this.sia;
          this.sia_result_text = "";
          this.sia_result_object = [];
          Object.keys(this.sia).forEach((key) => {
            if (key !== "len_dict" && key !== "complex_grade") {
              this.sia_result_object.push({
                key,
                label: this.humanizeAnalyzeAPIKey(key),
                value: this.sia[key],
              });
              // this.sia_result_text+='<div class="sia-row"><span class="title">'+this.humanizeAnalyzeAPIKey(key)+'</span><span class="value" v-tippy="{ arrow : true, theme: "light-border", maxWidth: 180 }" content="Для продолжения мониторинга включите переключатель">'+this.sia[key]+'</span></div>'
            }
          });
          // this.sia_result_text = ''
          // Object.keys(this.sia).forEach(key=>{
          //     if(key!=='len_dict' && key!=='complex_grade'){
          //         this.sia_result_text+='<div>'+this.sia[key]+'</div>'
          //     }
          // })

          // this.$bvModal.show('sia_result-hist')
          // setTimeout(()=>{
          //     let container = document.querySelector('#sia_progress-hist')

          //     let options5 = {
          //         hasNeedle: true,
          //         needleColor: 'black',
          //         arcColors: ['#c0392b', '#e67e22', '#f1c40f', '#27ae60'],
          //         arcDelimiters: [25, 50, 75],
          //         arcPadding: 6,
          //         arcPaddingColor: 'white',
          //         arcLabels: ['50', '100', '150'],
          //         arcLabelFontSize: false,
          //         //arcOverEffect: false,
          //         // label options
          //         rangeLabel: ['0', '200'],
          //         centralLabel: this.sia.complex_grade.toFixed(0),
          //         rangeLabelFontSize: false,
          //         labelsFont: 'Roboto',
          //     }

          //     GaugeChart.gaugeChart(container, 200, options5).updateNeedle(this.sia.complex_grade/2)

          // }, 500)
        })
        .catch(() => {
          this.sia_loading = false;
          this.sia_search_data_loading = false;
          clearInterval(this.sia_timer);
        });
    },
    async makeBulkTranslation({ objects, tables, object_tables, strings }) {
      console.warn("bulk input", objects, tables, object_tables);
      const request = [];
      const request_tmp = [];
      if (typeof objects[0] !== "undefined") {
        objects.forEach((item) => request.push(Object.values(item).map(item => {
          if (typeof item != 'object') {
            return item;
          } else {
            return "";
          }
        })));
      }
      if (typeof tables[0] !== "undefined") {
        tables.forEach((item) => {
          const values = Object.values(item).map(item => {
            if (typeof item != 'object') {
              return item;
            } else {
              return "";
            }
          });
          if (values.length > 0) request.push(values);
        });
      }
      if (typeof object_tables[0] !== "undefined") {
        object_tables.forEach((table) => {
          if (Array.isArray(table)) {
            table.forEach((object) => {
              const values = Object.values(object).map(item => {
                if (typeof item != 'object') {
                  return item;
                } else {
                  return "";
                }
              });
              if (values.length > 0) request.push(values);
            });
          }
        });
      }
      if (typeof strings[0] !== "undefined") {
        strings.forEach((object) => {
          request.push(object.stringValues);
        });
      }

      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        const objects_translated = [];
        const tables_translated = [];
        const object_tables_translated = [];

        const response = await axios.post(
          window.base +
          "/library/TranslateNextMultiArray?source=zh&target=" +
          locale,
          request,
        ); //.then(response=>{
        let global_counter = 0;

        const data = response.data;
        console.log(request, data);
        if (typeof objects[0] !== "undefined") {
          objects.forEach((item, index) => {
            objects_translated.push(
              response.data[global_counter].map(
                (translated) => JSON.parse(translated).translation,
              ),
            );
            global_counter++;
          });
        }
        if (typeof tables[0] !== "undefined") {
          tables.forEach((item, index) => {
            const values = Object.values(item);
            if (values.length > 0) {
              const keys = Object.keys(item);
              console.log("kekekey", keys);
              const translated_object = [];
              // keys.forEach((key, key_index)=>{
              response.data[global_counter].forEach((t, i) => {
                if (
                  keys[i] === "CreditCode" ||
                  keys[i] === "No" ||
                  keys[i] === "IndustryCode" ||
                  keys[i] === "SubIndustryCode" /*|| keys[i]=='Year'*/ ||
                  keys[i] == "PublishDate"
                ) {
                  translated_object.push({
                    Key: keys[i],
                    Translated: values[i],
                    Original: values[i],
                  });
                } else {
                  translated_object.push({
                    Key: keys[i],
                    Translated: JSON.parse(t).translation,
                    Original: values[i],
                  });
                }
              });
              // })
              global_counter++;
              tables_translated.push(translated_object);
            } else {
              tables_translated.push(item);
            }
          });
        }
        console.log("tables_translated", tables_translated);
        console.log("ot", object_tables);
        if (typeof object_tables[0] !== "undefined") {
          object_tables.forEach((object) => {
            const translated_object_table = [];
            console.log("objt", object);
            if (Array.isArray(object)) {
              object.forEach((item) => {
                const values = Object.values(item);
                console.warn(
                  "trans",
                  global_counter,
                  response.data[global_counter],
                );
                if (values.length > 0) {
                  const keys = Object.keys(item);
                  const translated_object = {};
                  keys.forEach((key, key_index) => {
                    console.log("keyj", key);
                    if (
                      typeof response.data[global_counter] !== "undefined" &&
                      Array.isArray(response.data[global_counter])
                    )
                      if (
                        typeof response.data[global_counter][key_index] !==
                        "undefined"
                      ) {
                        try {
                          translated_object[key] = JSON.parse(
                            response.data[global_counter][key_index],
                          ).translation;
                        } catch (e) {
                          console.log(e)
                        }
                      }
                  });

                  translated_object_table.push(translated_object);
                } else {
                  translated_object_table.push(item);
                }
                global_counter++;
              });
            }
            object_tables_translated.push(translated_object_table);
          });
        }
        console.log("ot_", object_tables_translated);
        const strings_translated = [];
        if (typeof strings[0] !== "undefined") {
          strings.forEach((object) => {
            const tmp_object = {};

            object.stringKeys.forEach((key, i) => {
              if (Array.isArray(response.data[global_counter]))
                tmp_object[key] = JSON.parse(
                  response.data[global_counter][i],
                ).translation;
            });
            strings_translated.push(tmp_object);
            global_counter++;
          });
        }

        console.warn(
          objects_translated.length,
          tables_translated.length,
          object_tables_translated.length,
        );
        return {
          objects: objects_translated,
          tables: tables_translated,
          object_tables: object_tables_translated,
          strings: strings_translated,
        };
        // })
      }
      return { objects, tables, object_tables, strings };
    },
    //             async makeBulkTranslation({objects, tables, object_tables, strings}){

    // const request = []
    // const request_tmp = []
    // if(typeof objects[0] !== 'undefined'){
    //     objects.forEach(item=>request.push(Object.values(item)))
    // }
    // if(typeof tables[0] !== 'undefined'){
    //     tables.forEach(item=>{
    //         const values = Object.values(item)
    //         if(values.length>0)
    //             request.push(values)
    //     })
    // }
    // if(typeof object_tables[0] !== 'undefined'){
    //     object_tables.forEach(table=>{
    //         if(Array.isArray(table)){
    //             table.forEach(object=>{
    //                 const values = Object.values(object)
    //                 if(values.length>0)
    //                     request.push(values)
    //             })
    //         }
    //     })
    // }
    // if(typeof strings[0] !== 'undefined'){
    //     strings.forEach(object=>{
    //         request.push(object.stringValues)
    //     })
    // }

    // var locale = this.$i18n.locale
    // switch(locale){
    //     case 'cn': locale = 'zh'; break;
    //     case 'en': locale = 'en'; break;
    //     case 'ru': locale = 'ru'; break;

    // }
    // if (locale !== 'zh') {
    //     const objects_translated = []
    //     const tables_translated = []
    //     const object_tables_translated = []
    //     const response = await axios.post(window.base + '/library/TranslateNextMultiArray?source=zh&target='+locale, request) //.then(response=>{
    //         let global_counter = 0;
    //         const data = response.data
    //         if(typeof objects[0] !== 'undefined'){
    //             objects.forEach((item, index)=>{
    //                 objects_translated.push(response.data[global_counter].map(translated => JSON.parse(translated).translation))
    //                 global_counter++
    //             })
    //         }
    //         if(typeof tables[0] !== 'undefined'){
    //             tables.forEach((item, index)=>{
    //                 const values = Object.values(item)
    //                 if(values.length>0){
    //                     const keys = Object.keys(item)
    //                     const translated_object = []
    //                     // keys.forEach((key, key_index)=>{
    //                     response.data[global_counter].forEach((t, i)=>{
    //                         if (keys[i] === 'CreditCode' || keys[i] === 'No' || keys[i] ==='IndustryCode' || keys[i] === 'SubIndustryCode')
    //                         translated_object.push({Key: keys[i], Translated: values[i], Original: values[i] })
    //                         else
    //                         translated_object.push({Key: keys[i], Translated: JSON.parse(t).translation, Original: values[i] })
    //                     })
    //                     // })

    //                     tables_translated.push(translated_object)
    //                     global_counter++
    //                 }else{
    //                     tables_translated.push(item)
    //                 }
    //             })
    //         }
    //         if(typeof object_tables[0] !== 'undefined'){
    //             object_tables.forEach(object=>{
    //                 const translated_object_table = []
    //                 if(Array.isArray(object)){
    //                     object.forEach(item=>{
    //                         const values = Object.values(item)

    //                         if(values.length>0){
    //                             const keys = Object.keys(item)
    //                             const translated_object = {}
    //                             keys.forEach((key, key_index)=>{
    //                                 if(typeof response.data[global_counter]!=='undefined' && Array.isArray(response.data[global_counter]))
    //                                     if(typeof response.data[global_counter][key_index]!=='undefined')
    //                                         translated_object[key] = JSON.parse(response.data[global_counter][key_index]).translation
    //                             })

    //                             translated_object_table.push(translated_object)
    //                             global_counter++
    //                         }else{
    //                             translated_object_table.push(item)
    //                         }
    //                     })
    //                 }
    //                 object_tables_translated.push(translated_object_table)
    //             })
    //         }
    //         const strings_translated = []
    //         if(typeof strings[0] !== 'undefined'){
    //             strings.forEach(object=>{
    //                 const tmp_object = {}

    //                 object.stringKeys.forEach((key, i)=>{
    //                     if(Array.isArray(response.data[global_counter]))
    //                         tmp_object[key] = JSON.parse(response.data[global_counter][i]).translation
    //                 })
    //                 strings_translated.push(tmp_object)
    //                 global_counter++
    //             })
    //         }

    //         return {objects: objects_translated, tables: tables_translated, object_tables: object_tables_translated, strings: strings_translated}
    //     // })

    // }
    // return {objects, tables, object_tables, strings}
    // },

    async getCompanyInfoTranslations(
      service_to_translate,
      tmp_service_info,
      tmp_response_info,
    ) {
      return new Promise(async (resolve, reject) => {
        const {
          objects: [service_info],
          tables: [areaList, industryList, revokeInfoList, parentInfoList],
          object_tables: [
            EntTagList,
            ChangeList,
            UsedNameList,
            ShareHolderList,
            EmployeeList,
            InvestList,
            BranchList,
            MoreEmailList,
          ],
        } = await this.makeBulkTranslation({
          objects: [service_to_translate],
          tables: [
            tmp_response_info.Area,
            tmp_response_info.Industry,
            tmp_response_info.RevokeInfo,
            tmp_response_info.ParentInfo,
          ],
          object_tables: [
            tmp_response_info.EntTagList,
            tmp_response_info.ChangeList,
            tmp_response_info.UsedNameList,
            tmp_response_info.ShareHolderList,
            tmp_response_info.EmployeeList,
            tmp_response_info.InvestList,
            tmp_response_info.BranchList,
            tmp_response_info.MoreEmailList,
          ],
          strings: [],
        });
        // console.log(data)
        let real_service_info = [];
        real_service_info = tmp_service_info.map((item, index) => {
          return [item[0], item[1], service_info[index]];
          // return item
        });
        // 91110105599635386M

        this.$set(this.company_info_data, "service_info", real_service_info);
        this.$set(this.company_info_data, "areaList", areaList);
        this.$set(this.company_info_data, "industryList", industryList);
        this.$set(this.company_info_data, "revokeInfoList", revokeInfoList);
        this.$set(this.company_info_data, "parentInfoList", parentInfoList);

        this.$set(this.company_info_data, "EntTagList", EntTagList);
        this.$set(this.company_info_data, "ChangeList", ChangeList);
        this.$set(this.company_info_data, "UsedNameList", UsedNameList);
        this.$set(this.company_info_data, "ShareHolderList", ShareHolderList);
        this.$set(this.company_info_data, "EmployeeList", EmployeeList);
        this.$set(this.company_info_data, "InvestList", InvestList);
        this.$set(this.company_info_data, "BranchList", BranchList);
        this.$set(this.company_info_data, "MoreEmailList", MoreEmailList);
        resolve();
      });
      /*await Promise.all( [
    //Formating main result object properties
    this.formatObjects(service_to_translate, tmp_service_info),
    //Formating object tables data
    this.formatObjectTablesCompany(tmp_response_info.Area,this.company_info_data.areaList),
    this.formatObjectTablesCompany(tmp_response_info.Industry,this.company_info_data.industryList),
    this.formatObjectTablesCompany(tmp_response_info.RevokeInfo,this.company_info_data.revokeInfoList),
    this.formatObjectTablesCompany(tmp_response_info.ParentInfo,this.company_info_data.parentInfoList),
    //Formating object array tables
    this.formatArrayObjectTables(tmp_response_info.EntTagList, this.company_info_data.EntTagList),
    this.formatArrayObjectTables(tmp_response_info.ChangeList, this.company_info_data.ChangeList),
    this.formatArrayObjectTables(tmp_response_info.UsedNameList, this.company_info_data.UsedNameList),
    this.formatArrayObjectTables(tmp_response_info.ShareHolderList, this.company_info_data.ShareHolderList),
    this.formatArrayObjectTables(tmp_response_info.EmployeeList, this.company_info_data.EmployeeList),
    this.formatArrayObjectTables(tmp_response_info.InvestList, this.company_info_data.InvestList),
    this.formatArrayObjectTables(tmp_response_info.BranchList, this.company_info_data.BranchList),
    this.formatArrayObjectTables(tmp_response_info.MoreEmailList, this.company_info_data.MoreEmailList)

    ]);*/
    },
    async getRiskScanTranslations(response, stringValues, stringKeys) {
      // this.formatStringValues(stringValues, stringKeys, this.risk_info_data)
      return new Promise(async (resolve, reject) => {
        const {
          objects: [],
          tables: [Industry, Area, RevokeInfo, ContactInfo],
          object_tables: [
            Penalty,
            Exceptions,
            ShiXinItems,
            ZhiXingItems,
            MPledge,
            Pledge,
            SpotCheck,
            CompanyTaxCreditItems,
            CompanyProducts,
            PermissionEciInfo,
            PenaltyCreditChina,
            Partners,
            Employees,
            Branches,
            ChangeRecords,
            EmergingIndusty,
            TagList,
            ARContactList,
            OriginalName,
          ],
          strings: [strings],
        } = await this.makeBulkTranslation({
          objects: [],
          tables: [
            response.Result.Industry,
            response.Result.Area,
            response.Result.RevokeInfo,
            response.Result.ContactInfo,
          ],
          object_tables: [
            response.Result.Penalty,
            response.Result.Exceptions,
            response.Result.ShiXinItems,
            response.Result.ZhiXingItems,
            response.Result.MPledge,
            response.Result.Pledge,
            response.Result.SpotCheck,
            response.Result.CompanyTaxCreditItems,
            response.Result.CompanyProducts,
            response.Result.PermissionEciInfo,
            response.Result.PenaltyCreditChina,
            response.Result.Partners,
            response.Result.Employees,
            response.Result.Branches,
            response.Result.ChangeRecords,
            response.Result.EmergingIndustyList,
            response.Result.TagList,
            response.Result.ARContactList,
            response.Result.OriginalName,
          ],
          strings: [{ stringValues, stringKeys }],
        });
        Object.keys(strings).forEach((key) => {
          this.$set(this.risk_info_data, key, strings[key]);
        });
        this.$set(this.risk_info_data, "Industry", Industry);
        this.$set(this.risk_info_data, "Area", Area);
        this.$set(this.risk_info_data, "RevokeInfo", RevokeInfo);
        this.$set(this.risk_info_data, "ContactInfo", ContactInfo);
        this.$set(this.risk_info_data, "Penalty", Penalty);
        this.$set(this.risk_info_data, "Exceptions", Exceptions);
        this.$set(this.risk_info_data, "ShiXinItems", ShiXinItems);
        this.$set(this.risk_info_data, "ZhiXingItems", ZhiXingItems);
        this.$set(this.risk_info_data, "MPledge", MPledge);
        this.$set(this.risk_info_data, "Pledge", Pledge);
        this.$set(this.risk_info_data, "SpotCheck", SpotCheck);
        this.$set(
          this.risk_info_data,
          "CompanyTaxCreditItems",
          CompanyTaxCreditItems,
        );
        this.$set(this.risk_info_data, "CompanyProducts", CompanyProducts);
        this.$set(this.risk_info_data, "PermissionEciInfo", PermissionEciInfo);
        this.$set(
          this.risk_info_data,
          "PenaltyCreditChina",
          PenaltyCreditChina,
        );
        this.$set(this.risk_info_data, "Partners", Partners);
        this.$set(this.risk_info_data, "Employees", Employees);
        this.$set(this.risk_info_data, "Branches", Branches);
        this.$set(this.risk_info_data, "ChangeRecords", ChangeRecords);
        this.$set(this.risk_info_data, "EmergingIndusty", EmergingIndusty);
        this.$set(this.risk_info_data, "TagList", TagList);
        this.$set(this.risk_info_data, "ARContactList", ARContactList);
        this.$set(this.risk_info_data, "OriginalName", OriginalName);
        resolve();
      });
      // await Promise.all( [
      //     // this.formatStringValues(stringValues, stringKeys, this.risk_info_data),
      //     this.formatObjectTables(response.data.Result.Industry,this.risk_info_data.Industry),
      //     this.formatObjectTables(response.data.Result.Area,this.risk_info_data.Area),
      //     this.formatObjectTables(response.data.Result.RevokeInfo,this.risk_info_data.RevokeInfo),
      //     this.formatObjectTables(response.data.Result.ContactInfo,this.risk_info_data.ContactInfo),
      //     this.formatArrayObjectTables(response.data.Result.Penalty, this.risk_info_data.Penalty),
      //     this.formatArrayObjectTables(response.data.Result.Exceptions, this.risk_info_data.Exceptions),
      //     this.formatArrayObjectTables(response.data.Result.ShiXinItems, this.risk_info_data.ShiXinItems),
      //     this.formatArrayObjectTables(response.data.Result.ZhiXingItems, this.risk_info_data.ZhiXingItems),
      //     this.formatArrayObjectTables(response.data.Result.MPledge, this.risk_info_data.MPledge),
      //     this.formatArrayObjectTables(response.data.Result.Pledge, this.risk_info_data.Pledge),
      //     this.formatArrayObjectTables(response.data.Result.SpotCheck, this.risk_info_data.SpotCheck),
      //     this.formatArrayObjectTables(response.data.Result.CompanyTaxCreditItems, this.risk_info_data.CompanyTaxCreditItems),
      //     this.formatArrayObjectTables(response.data.Result.CompanyProducts, this.risk_info_data.CompanyProducts),
      //     this.formatArrayObjectTables(response.data.Result.PermissionEciInfo, this.risk_info_data.PermissionEciInfo),
      //     this.formatArrayObjectTables(response.data.Result.PenaltyCreditChina, this.risk_info_data.PenaltyCreditChina),
      //     this.formatArrayObjectTables(response.data.Result.Partners, this.risk_info_data.Partners),
      //     this.formatArrayObjectTables(response.data.Result.Employees, this.risk_info_data.Employees),
      //     this.formatArrayObjectTables(response.data.Result.Branches, this.risk_info_data.Branches),
      //     this.formatArrayObjectTables(response.data.Result.ChangeRecords, this.risk_info_data.ChangeRecords),
      //     this.formatArrayObjectTables(response.data.Result.EmergingIndustyList, this.risk_info_data.EmergingIndusty),
      //     this.formatArrayObjectTables(response.data.Result.TagList, this.risk_info_data.TagList),
      //     this.formatArrayObjectTables(response.data.Result.ARContactList, this.risk_info_data.ARContactList),
      //     this.formatArrayObjectTables(response.data.Result.OriginalName, this.risk_info_data.OriginalName),

      // ]);
    },
    getAnnualTranslations(result) {
      return new Promise((resolve, reject) => {
        const result_ = [];
        result.map((res, index) => {
          this.makeBulkTranslation({
            objects: [],
            tables: [res.BasicInfoData, res.AssetsData, res.SocialInsurance],
            object_tables: [
              res.ChangeList,
              res.InvestInfoList,
              res.PartnerList,
              res.ProvideAssuranceList,
              res.StockChangeList,
              res.WebSiteList,
              res.AdministrationLicenseList,
              res.BranchList,
              res.EmployeeList,
            ],
            strings: [],
          }).then(
            ({
              objects: [],
              tables: [BasicInfoData_, AssetsData_, SocialInsurance_],
              object_tables: [
                ChangeList_,
                InvestInfoList_,
                PartnerList_,
                ProvideAssuranceList_,
                StockChangeList_,
                WebSiteList_,
                AdministrationLicenseList_,
                BranchList_,
                EmployeeList_,
              ],
            }) => {
              console.warn(PartnerList_);
              console.warn({
                BasicInfoData: BasicInfoData_,
                AssetsData: AssetsData_,
                SocialInsurance: SocialInsurance_,
                ChangeList: ChangeList_,
                InvestInfoList: InvestInfoList_,
                PartnerList: PartnerList_,
                ProvideAssuranceList: ProvideAssuranceList_,
                StockChangeList: StockChangeList_,
                WebSiteList: WebSiteList_,
                AdministrationLicenseList: AdministrationLicenseList_,
                BranchList: BranchList_,
                EmployeeList: EmployeeList_,
              });
              result_.push({
                BasicInfoData: BasicInfoData_,
                AssetsData: AssetsData_,
                SocialInsurance: SocialInsurance_,
                ChangeList: ChangeList_,
                InvestInfoList: InvestInfoList_,
                PartnerList: PartnerList_,
                ProvideAssuranceList: ProvideAssuranceList_,
                StockChangeList: StockChangeList_,
                WebSiteList: WebSiteList_,
                AdministrationLicenseList: AdministrationLicenseList_,
                BranchList: BranchList_,
                EmployeeList: EmployeeList_,
              });
              console.warn(result_);
              if (index == result.length - 1) {
                resolve(result_);
              }
            },
          );
        });
      });

      // return await Promise.all(result.map(async (res, index) => {
      //     const tmp = {
      //         BasicInfoData: {},
      //         AssetsData: {},
      //         SocialInsurance: {},
      //         ChangeList: [],
      //         InvestInfoList: [],
      //         PartnerList: [],
      //         ProvideAssuranceList: [],
      //         StockChangeList: [],
      //         WebSiteList: [],
      //         AdministrationLicenseList: [],
      //         BranchList: [],
      //         EmployeeList: [],
      //     }
      //     await this.formatObjectTables(res.BasicInfoData, tmp.BasicInfoData);
      //     await this.formatObjectTables(res.AssetsData, tmp.AssetsData);
      //     await this.formatObjectTables(res.SocialInsurance, tmp.SocialInsurance);
      //     await this.formatArrayObjectTables(res.ChangeList, tmp.ChangeList);
      //     await this.formatArrayObjectTables(res.InvestInfoList, tmp.InvestInfoList);
      //     await this.formatArrayObjectTables(res.PartnerList, tmp.PartnerList);
      //     await this.formatArrayObjectTables(res.ProvideAssuranceList, tmp.ProvideAssuranceList);
      //     await this.formatArrayObjectTables(res.StockChangeList, tmp.StockChangeList);
      //     await this.formatArrayObjectTables(res.WebSiteList, tmp.WebSiteList);
      //     await this.formatArrayObjectTables(res.AdministrationLicenseList, tmp.AdministrationLicenseList);
      //     await this.formatArrayObjectTables(res.BranchList, tmp.BranchList);
      //     await this.formatArrayObjectTables(res.EmployeeList, tmp.EmployeeList);

      //     result[index] = tmp
      // }));
    },
    // getAnnualTranslations(result) {
    // return  new Promise( (resolve, reject)=>{
    //     const result_ = []
    //      result.map( (res, index) => {
    //         this.makeBulkTranslation({
    //             objects: [],
    //             tables: [
    //                 res.BasicInfoData,
    //                 res.AssetsData,
    //                 res.SocialInsurance
    //             ],
    //             object_tables: [
    //                 res.ChangeList,
    //                 res.InvestInfoList,
    //                 res.PartnerList,
    //                 res.ProvideAssuranceList,
    //                 res.StockChangeList,
    //                 res.WebSiteList,
    //                 res.AdministrationLicenseList,
    //                 res.BranchList,
    //                 res.EmployeeList
    //             ],
    //             strings: []
    //         }).then(({
    //             objects: [],
    //             tables: [
    //                 BasicInfoData,
    //                 AssetsData,
    //                 SocialInsurance
    //             ],
    //             object_tables: [
    //                 ChangeList,
    //                 InvestInfoList,
    //                 PartnerList,
    //                 ProvideAssuranceList,
    //                 StockChangeList,
    //                 WebSiteList,
    //                 AdministrationLicenseList,
    //                 BranchList,
    //                 EmployeeList
    //             ]
    //         })=>{
    //             result_.push({
    //                 BasicInfoData,
    //                 AssetsData,
    //                 SocialInsurance,
    //                 ChangeList,
    //                 InvestInfoList,
    //                 PartnerList,
    //                 ProvideAssuranceList,
    //                 StockChangeList,
    //                 WebSiteList,
    //                 AdministrationLicenseList,
    //                 BranchList,
    //                 EmployeeList
    //             })
    //             if(index==result.length-1){
    //                 resolve(result_)
    //             }
    //         })

    //     })

    // })

    //     // return await Promise.all(result.map(async (res, index) => {
    //     //     const tmp = {
    //     //         BasicInfoData: {},
    //     //         AssetsData: {},
    //     //         SocialInsurance: {},
    //     //         ChangeList: [],
    //     //         InvestInfoList: [],
    //     //         PartnerList: [],
    //     //         ProvideAssuranceList: [],
    //     //         StockChangeList: [],
    //     //         WebSiteList: [],
    //     //         AdministrationLicenseList: [],
    //     //         BranchList: [],
    //     //         EmployeeList: [],
    //     //     }
    //     //     await this.formatObjectTables(res.BasicInfoData, tmp.BasicInfoData);
    //     //     await this.formatObjectTables(res.AssetsData, tmp.AssetsData);
    //     //     await this.formatObjectTables(res.SocialInsurance, tmp.SocialInsurance);
    //     //     await this.formatArrayObjectTables(res.ChangeList, tmp.ChangeList);
    //     //     await this.formatArrayObjectTables(res.InvestInfoList, tmp.InvestInfoList);
    //     //     await this.formatArrayObjectTables(res.PartnerList, tmp.PartnerList);
    //     //     await this.formatArrayObjectTables(res.ProvideAssuranceList, tmp.ProvideAssuranceList);
    //     //     await this.formatArrayObjectTables(res.StockChangeList, tmp.StockChangeList);
    //     //     await this.formatArrayObjectTables(res.WebSiteList, tmp.WebSiteList);
    //     //     await this.formatArrayObjectTables(res.AdministrationLicenseList, tmp.AdministrationLicenseList);
    //     //     await this.formatArrayObjectTables(res.BranchList, tmp.BranchList);
    //     //     await this.formatArrayObjectTables(res.EmployeeList, tmp.EmployeeList);

    //     //     result[index] = tmp
    //     // }));
    // },
    // async makeBulkTranslation({objects, tables, object_tables, strings}){

    //     const request = []
    //     const request_tmp = []
    //     if(typeof objects[0] !== 'undefined'){
    //         objects.forEach(item=>request.push(Object.values(item)))
    //     }
    //     if(typeof tables[0] !== 'undefined'){
    //         tables.forEach(item=>{
    //             const values = Object.values(item)
    //             if(values.length>0)
    //                 request.push(values)
    //         })
    //     }
    //     if(typeof object_tables[0] !== 'undefined'){
    //         object_tables.forEach(table=>{
    //             table.forEach(object=>{
    //                 const values = Object.values(object)
    //                 if(values.length>0)
    //                     request.push(values)
    //             })

    //         })
    //     }
    //     if(typeof strings[0] !== 'undefined'){
    //         strings.forEach(object=>{
    //             request.push(object.values)
    //         })
    //     }

    //     var locale = this.$i18n.locale
    //     switch(locale){
    //         case 'cn': locale = 'zh'; break;
    //         case 'en': locale = 'en'; break;
    //         case 'ru': locale = 'ru'; break;

    //     }
    //     if (locale !== 'zh') {
    //         const objects_translated = []
    //         const tables_translated = []
    //         const object_tables_translated = []
    //         const response = await axios.post(window.base + '/library/TranslateNextMultiArray?source=zh&target='+locale, request) //.then(response=>{
    //             let global_counter = 0;
    //             const data = response.data
    //             if(typeof objects[0] !== 'undefined'){
    //                 objects.forEach((item, index)=>{
    //                     objects_translated.push(response.data[global_counter].map(translated => JSON.parse(translated).translation))
    //                     global_counter++
    //                 })
    //             }
    //             if(typeof tables[0] !== 'undefined'){
    //                 tables.forEach((item, index)=>{
    //                     const values = Object.values(item)
    //                     if(values.length>0){
    //                         const keys = Object.keys(item)
    //                         const translated_object = []
    //                         // keys.forEach((key, key_index)=>{
    //                         response.data[global_counter].forEach((t, i)=>{
    //                             if (keys[i] === 'CreditCode' || keys[i] === 'No' || keys[i] ==='IndustryCode' || keys[i] === 'SubIndustryCode')
    //                             translated_object.push({Key: keys[i], Translated: values[i], Original: values[i] })
    //                             else
    //                             translated_object.push({Key: keys[i], Translated: JSON.parse(t).translation, Original: values[i] })
    //                         })
    //                         // })

    //                         tables_translated.push(translated_object)
    //                         global_counter++
    //                     }else{
    //                         tables_translated.push(item)
    //                     }
    //                 })
    //             }
    //             if(typeof object_tables[0] !== 'undefined'){
    //                 object_tables.forEach(object=>{
    //                     const translated_object_table = []
    //                     object.forEach(item=>{
    //                         const values = Object.values(item)

    //                         if(values.length>0){
    //                             const keys = Object.keys(item)
    //                             const translated_object = {}
    //                             keys.forEach((key, key_index)=>{
    //                                 translated_object[key] = JSON.parse(response.data[global_counter][key_index]).translation
    //                             })

    //                             translated_object_table.push(translated_object)
    //                             global_counter++
    //                         }else{
    //                             translated_object_table.push(item)
    //                         }
    //                     })
    //                     object_tables_translated.push(translated_object_table)
    //                 })
    //             }
    //             const strings_translated = []
    //             if(typeof strings[0] !== 'undefined'){
    //                 strings.forEach(object=>{

    //                     const tmp_object = {}

    //                     object.keys.forEach((key, i)=>{
    //                         tmp_object[key] = JSON.parse(response.data[global_counter][i])
    //                     })
    //                     strings_translated.push(tmp_object)
    //                     global_counter++
    //                 })
    //             }

    //             return {objects: objects_translated, tables: tables_translated, object_tables: object_tables_translated, strings: strings_translated}
    //         // })

    //     }
    //     return {objects, tables, object_tables}
    // },

    // async getCompanyInfoTranslations(service_to_translate, tmp_service_info, tmp_response_info) {
    //     return new Promise(async (resolve, reject)=>{
    //     const {
    //         objects: [service_info],
    //         tables: [
    //             areaList,
    //             industryList,
    //             revokeInfoList,
    //             parentInfoList
    //         ],
    //         object_tables: [
    //             EntTagList,
    //             ChangeList,
    //             UsedNameList,
    //             ShareHolderList,
    //             EmployeeList,
    //             InvestList,
    //             BranchList,
    //             MoreEmailList
    //         ]
    //     } = await this.makeBulkTranslation({
    //             objects: [service_to_translate, ],
    //             tables: [
    //                 tmp_response_info.Area,
    //                 tmp_response_info.Industry,
    //                 tmp_response_info.RevokeInfo,
    //                 tmp_response_info.ParentInfo
    //             ],
    //             object_tables: [
    //                 tmp_response_info.EntTagList,
    //                 tmp_response_info.ChangeList,
    //                 tmp_response_info.UsedNameList,
    //                 tmp_response_info.ShareHolderList,
    //                 tmp_response_info.EmployeeList,
    //                 tmp_response_info.InvestList,
    //                 tmp_response_info.BranchList,
    //                 tmp_response_info.MoreEmailList,
    //             ],
    //             strings: []
    //         }
    //     )
    //     // console.log(data)
    //     let real_service_info = []
    //     real_service_info = tmp_service_info.map((item, index)=>{
    //         return [item[0], item[1], service_info[index]]
    //         // return item
    //     })
    //     // 91110105599635386M

    //     this.$set(this.company_info_data, 'service_info', real_service_info)
    //     this.$set(this.company_info_data, 'areaList', areaList)
    //     this.$set(this.company_info_data, 'industryList', industryList)
    //     this.$set(this.company_info_data, 'revokeInfoList', revokeInfoList)
    //     this.$set(this.company_info_data, 'parentInfoList', parentInfoList)

    //     this.$set(this.company_info_data, 'EntTagList', EntTagList)
    //     this.$set(this.company_info_data, 'ChangeList', ChangeList)
    //     this.$set(this.company_info_data, 'UsedNameList', UsedNameList)
    //     this.$set(this.company_info_data, 'ShareHolderList', ShareHolderList)
    //     this.$set(this.company_info_data, 'EmployeeList', EmployeeList)
    //     this.$set(this.company_info_data, 'InvestList', InvestList)
    //     this.$set(this.company_info_data, 'BranchList', BranchList)
    //     this.$set(this.company_info_data, 'MoreEmailList', MoreEmailList)
    //     resolve()
    //     })
    //         /*await Promise.all( [
    //         //Formating main result object properties
    //         this.formatObjects(service_to_translate, tmp_service_info),
    //         //Formating object tables data
    //         this.formatObjectTablesCompany(tmp_response_info.Area,this.company_info_data.areaList),
    //         this.formatObjectTablesCompany(tmp_response_info.Industry,this.company_info_data.industryList),
    //         this.formatObjectTablesCompany(tmp_response_info.RevokeInfo,this.company_info_data.revokeInfoList),
    //         this.formatObjectTablesCompany(tmp_response_info.ParentInfo,this.company_info_data.parentInfoList),
    //         //Formating object array tables
    //         this.formatArrayObjectTables(tmp_response_info.EntTagList, this.company_info_data.EntTagList),
    //         this.formatArrayObjectTables(tmp_response_info.ChangeList, this.company_info_data.ChangeList),
    //         this.formatArrayObjectTables(tmp_response_info.UsedNameList, this.company_info_data.UsedNameList),
    //         this.formatArrayObjectTables(tmp_response_info.ShareHolderList, this.company_info_data.ShareHolderList),
    //         this.formatArrayObjectTables(tmp_response_info.EmployeeList, this.company_info_data.EmployeeList),
    //         this.formatArrayObjectTables(tmp_response_info.InvestList, this.company_info_data.InvestList),
    //         this.formatArrayObjectTables(tmp_response_info.BranchList, this.company_info_data.BranchList),
    //         this.formatArrayObjectTables(tmp_response_info.MoreEmailList, this.company_info_data.MoreEmailList)

    //         ]);*/
    // },
    // async getRiskScanTranslations(response, stringValues, stringKeys) {
    //     // this.formatStringValues(stringValues, stringKeys, this.risk_info_data)
    //     return new Promise(async (resolve, reject) => {
    //         const {
    //             objects: [],
    //             tables: [Industry, Area, RevokeInfo, ContactInfo],
    //             object_tables: [
    //                 Penalty,
    //                 Exceptions,
    //                 ShiXinItems,
    //                 ZhiXingItems,
    //                 MPledge,
    //                 Pledge,
    //                 SpotCheck,
    //                 CompanyTaxCreditItems,
    //                 CompanyProducts,
    //                 PermissionEciInfo,
    //                 PenaltyCreditChina,
    //                 Partners,
    //                 Employees,
    //                 Branches,
    //                 ChangeRecords,
    //                 EmergingIndusty,
    //                 TagList,
    //                 ARContactList,
    //                 OriginalName
    //             ],
    //             strings: [strings]
    //         } = await this.makeBulkTranslation({
    //             objects: [],
    //             tables: [
    //                 response.data.Result.Industry,
    //                 response.data.Result.Area,
    //                 response.data.Result.RevokeInfo,
    //                 response.data.Result.ContactInfo
    //             ],
    //             object_tables: [
    //                 response.data.Result.Penalty,
    //                 response.data.Result.Exceptions,
    //                 response.data.Result.ShiXinItems,
    //                 response.data.Result.ZhiXingItems,
    //                 response.data.Result.MPledge,
    //                 response.data.Result.Pledge,
    //                 response.data.Result.SpotCheck,
    //                 response.data.Result.CompanyTaxCreditItems,
    //                 response.data.Result.CompanyProducts,
    //                 response.data.Result.PermissionEciInfo,
    //                 response.data.Result.PenaltyCreditChina,
    //                 response.data.Result.Partners,
    //                 response.data.Result.Employees,
    //                 response.data.Result.Branches,
    //                 response.data.Result.ChangeRecords,
    //                 response.data.Result.EmergingIndustyList,
    //                 response.data.Result.TagList,
    //                 response.data.Result.ARContactList,
    //                 response.data.Result.OriginalName
    //             ],
    //             strings: [
    //                 {stringValues, stringKeys}
    //             ]
    //         })
    //         Object.keys(strings).forEach(key => {
    //             this.$set(this.risk_info_data, key, strings[key])
    //         })
    //         this.$set(this.risk_info_data, 'Industry', Industry)
    //         this.$set(this.risk_info_data, 'Area', Area)
    //         this.$set(this.risk_info_data, 'RevokeInfo', RevokeInfo)
    //         this.$set(this.risk_info_data, 'ContactInfo', ContactInfo)
    //         this.$set(this.risk_info_data, 'Penalty', Penalty)
    //         this.$set(this.risk_info_data, 'Exceptions', Exceptions)
    //         this.$set(this.risk_info_data, 'ShiXinItems', ShiXinItems)
    //         this.$set(this.risk_info_data, 'ZhiXingItems', ZhiXingItems)
    //         this.$set(this.risk_info_data, 'MPledge', MPledge)
    //         this.$set(this.risk_info_data, 'Pledge', Pledge)
    //         this.$set(this.risk_info_data, 'SpotCheck', SpotCheck)
    //         this.$set(this.risk_info_data, 'CompanyTaxCreditItems', CompanyTaxCreditItems)
    //         this.$set(this.risk_info_data, 'CompanyProducts', CompanyProducts)
    //         this.$set(this.risk_info_data, 'PermissionEciInfo', PermissionEciInfo)
    //         this.$set(this.risk_info_data, 'PenaltyCreditChina', PenaltyCreditChina)
    //         this.$set(this.risk_info_data, 'Partners', Partners)
    //         this.$set(this.risk_info_data, 'Employees', Employees)
    //         this.$set(this.risk_info_data, 'Branches', Branches)
    //         this.$set(this.risk_info_data, 'ChangeRecords', ChangeRecords)
    //         this.$set(this.risk_info_data, 'EmergingIndusty', EmergingIndusty)
    //         this.$set(this.risk_info_data, 'TagList', TagList)
    //         this.$set(this.risk_info_data, 'ARContactList', ARContactList)
    //         this.$set(this.risk_info_data, 'OriginalName', OriginalName)

    //     })
    //     await Promise.all( [
    //         // this.formatStringValues(stringValues, stringKeys, this.risk_info_data),
    //         this.formatObjectTables(response.data.Result.Industry,this.risk_info_data.Industry),
    //         this.formatObjectTables(response.data.Result.Area,this.risk_info_data.Area),
    //         this.formatObjectTables(response.data.Result.RevokeInfo,this.risk_info_data.RevokeInfo),
    //         this.formatObjectTables(response.data.Result.ContactInfo,this.risk_info_data.ContactInfo),
    //         this.formatArrayObjectTables(response.data.Result.Penalty, this.risk_info_data.Penalty),
    //         this.formatArrayObjectTables(response.data.Result.Exceptions, this.risk_info_data.Exceptions),
    //         this.formatArrayObjectTables(response.data.Result.ShiXinItems, this.risk_info_data.ShiXinItems),
    //         this.formatArrayObjectTables(response.data.Result.ZhiXingItems, this.risk_info_data.ZhiXingItems),
    //         this.formatArrayObjectTables(response.data.Result.MPledge, this.risk_info_data.MPledge),
    //         this.formatArrayObjectTables(response.data.Result.Pledge, this.risk_info_data.Pledge),
    //         this.formatArrayObjectTables(response.data.Result.SpotCheck, this.risk_info_data.SpotCheck),
    //         this.formatArrayObjectTables(response.data.Result.CompanyTaxCreditItems, this.risk_info_data.CompanyTaxCreditItems),
    //         this.formatArrayObjectTables(response.data.Result.CompanyProducts, this.risk_info_data.CompanyProducts),
    //         this.formatArrayObjectTables(response.data.Result.PermissionEciInfo, this.risk_info_data.PermissionEciInfo),
    //         this.formatArrayObjectTables(response.data.Result.PenaltyCreditChina, this.risk_info_data.PenaltyCreditChina),
    //         this.formatArrayObjectTables(response.data.Result.Partners, this.risk_info_data.Partners),
    //         this.formatArrayObjectTables(response.data.Result.Employees, this.risk_info_data.Employees),
    //         this.formatArrayObjectTables(response.data.Result.Branches, this.risk_info_data.Branches),
    //         this.formatArrayObjectTables(response.data.Result.ChangeRecords, this.risk_info_data.ChangeRecords),
    //         this.formatArrayObjectTables(response.data.Result.EmergingIndustyList, this.risk_info_data.EmergingIndusty),
    //         this.formatArrayObjectTables(response.data.Result.TagList, this.risk_info_data.TagList),
    //         this.formatArrayObjectTables(response.data.Result.ARContactList, this.risk_info_data.ARContactList),
    //         this.formatArrayObjectTables(response.data.Result.OriginalName, this.risk_info_data.OriginalName),

    //     ]);

    // },
    // async getAnnualTranslations(result) {
    //     return new Promise(async (resolve, reject)=>{
    //         result.map(async (res, index) => {
    //             const {
    //                 objects: [],
    //                 tables: [
    //                     BasicInfoData,
    //                     AssetsData,
    //                     SocialInsurance
    //                 ],
    //                 object_tables: [
    //                     ChangeList,
    //                     InvestInfoList,
    //                     PartnerList,
    //                     ProvideAssuranceList,
    //                     StockChangeList,
    //                     WebSiteList,
    //                     AdministrationLicenseList,
    //                     BranchList,
    //                     EmployeeList
    //                 ]
    //             } = await this.makeBulkTranslation({
    //                 objects: [],
    //                 tables: [
    //                     res.BasicInfoData,
    //                     res.AssetsData,
    //                     res.SocialInsurance
    //                 ],
    //                 object_tables: [
    //                     res.ChangeList,
    //                     res.InvestInfoList,
    //                     res.PartnerList,
    //                     res.ProvideAssuranceList,
    //                     res.StockChangeList,
    //                     res.WebSiteList,
    //                     res.AdministrationLicenseList,
    //                     res.BranchList,
    //                     res.EmployeeList
    //                 ],
    //                 strings: []
    //             })
    //             result[index] = {
    //                 BasicInfoData,
    //                 AssetsData,
    //                 SocialInsurance,
    //                 ChangeList,
    //                 InvestInfoList,
    //                 PartnerList,
    //                 ProvideAssuranceList,
    //                 StockChangeList,
    //                 WebSiteList,
    //                 AdministrationLicenseList,
    //                 BranchList,
    //                 EmployeeList
    //             }
    //         })
    //     })

    //     return await Promise.all(result.map(async (res, index) => {
    //         const tmp = {
    //             BasicInfoData: {},
    //             AssetsData: {},
    //             SocialInsurance: {},
    //             ChangeList: [],
    //             InvestInfoList: [],
    //             PartnerList: [],
    //             ProvideAssuranceList: [],
    //             StockChangeList: [],
    //             WebSiteList: [],
    //             AdministrationLicenseList: [],
    //             BranchList: [],
    //             EmployeeList: [],
    //         }
    //         await this.formatObjectTables(res.BasicInfoData, tmp.BasicInfoData);
    //         await this.formatObjectTables(res.AssetsData, tmp.AssetsData);
    //         await this.formatObjectTables(res.SocialInsurance, tmp.SocialInsurance);
    //         await this.formatArrayObjectTables(res.ChangeList, tmp.ChangeList);
    //         await this.formatArrayObjectTables(res.InvestInfoList, tmp.InvestInfoList);
    //         await this.formatArrayObjectTables(res.PartnerList, tmp.PartnerList);
    //         await this.formatArrayObjectTables(res.ProvideAssuranceList, tmp.ProvideAssuranceList);
    //         await this.formatArrayObjectTables(res.StockChangeList, tmp.StockChangeList);
    //         await this.formatArrayObjectTables(res.WebSiteList, tmp.WebSiteList);
    //         await this.formatArrayObjectTables(res.AdministrationLicenseList, tmp.AdministrationLicenseList);
    //         await this.formatArrayObjectTables(res.BranchList, tmp.BranchList);
    //         await this.formatArrayObjectTables(res.EmployeeList, tmp.EmployeeList);

    //         result[index] = tmp
    //     }));
    // },

    load() {
      console.log(this.$route.name);
      let isLookup = 3;
      if (
        this.$route.name == "cn-search-history-note" ||
        this.$route.name == "business-note" ||
        this.$route.name == "business-note-hist-tab" ||
        this.$route.name == "bn-single"
      )
        isLookup = 0;
      if (
        this.$route.name == "find-partner-410" ||
        this.$route.name == "cs-410-single"
      )
        isLookup = 1;
      if (this.$route.name == "short-search")
        isLookup = 4;
      if (this.$route.name == "find-partner-410-admin")
        isLookup = 5;
      axios
        .get(
          window.base +
          "/contract/getSearchLog?page=" +
          this.page +
          "&pageSize=" +
          this.perpage +
          "&isLookup=" +
          isLookup,
        )
        .then((response) => {
          console.log(response);
          this.history = response.data;
          this.total_count = parseInt(response.data[0].total_count);

          if (
            this.$route.name == "bn-single" ||
            this.$route.name == "cs-single" ||
            this.$route.name == "cs-410-single"
          ) {
            this.openSearch(this.$route.params.data);
          }
        });
    },
    openSearch(item) {
      console.log(item);
      this.analyse_id = item.id;
      this.analyse_title = item.search_text;
      // console.log(item)
      let log_data = JSON.parse(item.log_data);
      try {
        log_data = JSON.parse(log_data);
      } catch (e) {}

      if (
        this.$route.name == "cn-search-history-note" ||
        this.$route.name == "business-note" ||
        this.$route.name == "business-note-hist-tab" ||
        this.$route.name == "bn-single" ||
        this.$route.name == 'short-search'
      ) {
        this.sendToAnalyze(this.analyse_id);
      }

      this.initializeData();
      Object.entries(log_data).forEach((data_item) => {
        this.service_code_list.push(data_item[1].service_code);
        switch (data_item[1].service_code) {
          case "430":
            this.company_info_data = data_item[1].result;
            this.pdf_document.company_info_data = this.company_info_data;
            break;
          case "213+736":
            console.log('dataitem1', data_item[1]);
            this.short_search_result = data_item[1].result;
            this.short_search_result.sia = this.sia;


            // this.annual_info_data = data_item[1].annual.result;
            // this.pdf_document.annual = this.annual_info_data;
            // this.risk_info_data = data_item[1].risk.result;
            // this.pdf_document.risk = this.risk_info_data;
            break;
          case "213":
            this.annual_info_data = data_item[1].result;
            this.pdf_document.annual_info_data = this.annual_info_data;
            break;
          case "736":
            this.risk_info_data = data_item[1].result;
            this.pdf_document.risk_info_data = this.risk_info_data;
            break;
          case "930":
            this.court_info_data = data_item[1].result;
            this.pdf_document.court_info_data = this.court_info_data;
            break;
          case "701":
            this.news_info_data = data_item[1].result;
            this.pdf_document.news_info_data = this.news_info_data;
            break;
          case "886":
            this.business_fuzzy_info = data_item[1].result;
            this.pdf_document.business_fuzzy_info = this.business_fuzzy_info;
            break;
          case "410":
          case "410_admin":
            this.traffic_light = data_item[1].result;
            this.traffic_light = this.traffic_light.map((item) => {
              item = { ...item, ...item.data_ru.Result };
              return item;
            });
            this.traffic_light.sort((a, b) => {
              let ai = parseInt(a.grade);
              let bi = parseInt(b.grade);

              if (ai < bi) return 1;
              if (ai > bi) return -1;
              return 0;
            });
            this.pdf_document.traffic_light = this.traffic_light;

            break;
        }
      });
      this.total_loaded = 3;
      this.$bvModal.show("display_result");
      return;
      this.initializeData();
      this.current_history_item = item;
      this.pdf_parameters.keyWord = item.search_text;
      this.pdf_parameters.keyWord886 = "";
      this.pdf_parameters.provinceCode = "";
      this.pdf_parameters.cityCode = "";
      this.pdf_parameters.searcher_full_name =
        item.first_name + " " + item.middle_name + " " + item.last_name;

      if (typeof this.current_history_item.log_data !== "object")
        this.current_history_item.log_data = JSON.parse(
          JSON.parse(item.log_data),
        );

      console.log("opening item");
      console.log(this.current_history_item.log_data);
      switch (this.current_history_item.service_code) {
        case "430":
          this.service_code_list = ["430"];
          this.total_loaded++;
          var tmp_response_info = this.current_history_item.log_data.Result;

          if (!this.current_history_item.log_data.Result) {
            this.no_result = true;
            this.total_loaded = 3;
            this.$bvModal.show("display_result");
            return;
          }

          // transform change list data
          if (
            tmp_response_info.ChangeList &&
            tmp_response_info.ChangeList.length > 0
          ) {
            tmp_response_info.ChangeList.forEach((chg) => {
              if (typeof chg.BeforeList !== "string")
                chg.BeforeList = chg.BeforeList.join(",");
              if (typeof chg.AfterList !== "string")
                chg.AfterList = chg.AfterList.join(",");
            });
          }

          var tmp_service_info = Object.entries(
            this.current_history_item.log_data.Result,
          );

          tmp_service_info = tmp_service_info.filter(
            (item) =>
              typeof item[1] !== "object" && !_.isArray(item[1]) && item[1],
          );

          // Translating packages of text (columns of tables)
          var service_to_translate = [];
          tmp_service_info.forEach(([key, value]) => {
            service_to_translate.push(value);
          });
          this.total_loaded++;
          this.getCompanyInfoTranslations(
            service_to_translate,
            tmp_service_info,
            tmp_response_info,
          ).then((r) => {
            this.total_loaded++;
            this.search_company_info_complete = true;
            this.company_info_data.response_info = tmp_response_info;
            this.pdf_document.company_info_data = this.company_info_data;
          });
          break;
        case "213":
          this.service_code_list = ["213"];

          this.total_loaded++;
          var result = this.current_history_item.log_data.Result;

          if (!this.current_history_item.log_data.Result) {
            this.no_result = true;
            this.total_loaded = 3;
            this.$bvModal.show("display_result");
            return;
          }

          let result_ = result.map((item) => {
            const year = item.Year;
            const no = item.No;
            const date = item.PublishDate;

            item.AssetsData.Year = year;
            item.AssetsData.No = no;
            item.AssetsData.PublishDate = date;
            item.BasicInfoData.Year = year;
            item.BasicInfoData.No = no;
            item.BasicInfoData.PublishDate = date;
            item.SocialInsurance.Year = year;
            item.SocialInsurance.No = no;
            item.SocialInsurance.PublishDate = date;

            item.BranchList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.ChangeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.EmployeeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.InvestInfoList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.ProvideAssuranceList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.StockChangeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            return item;
          });

          this.getAnnualTranslations(result_).then((r) => {
            console.log("trans done");
            // this.addLoading('213');
            console.log("before group", r.length, r);
            //console.log('kkkk;', result.InvestInfoList)
            this.groupAnnualResults(r).then((re) => {
              this.anual_search_complete = true;
              this.total_loaded = 3;
              //console.log('annual info data');
              //console.log(this.annual_info_data);
              //console.log(this.anual_search_complete)
              //console.log(this.loading);
              this.pdf_document.annual_info_data = this.annual_info_data;
            });
            //console.log('loading annual 2')
          });
          // this.getAnnualTranslations(result).then(r => {

          //     this.total_loaded++;
          //     this.groupAnnualResults(result).then(re => {
          //         this.anual_search_complete = true;
          //         this.total_loaded++;

          //     })

          // })
          break;
        case "736":
          this.service_code_list = ["736"];

          if (!this.current_history_item.log_data.Result) {
            this.no_result = true;
            this.total_loaded = 3;
            this.$bvModal.show("display_result");
            return;
          }
          this.total_loaded++;
          var locale = this.$i18n.locale;
          var tmp = Object.entries(this.current_history_item.log_data.Result);
          tmp = tmp.filter(
            (item) => typeof item[1] !== "object" && !_.isArray(item[1]),
          );
          var stringValues = tmp.map((str) => {
            return str[1];
          });
          var stringKeys = tmp.map((str) => {
            return str[0];
          });
          this.total_loaded++;
          if (locale !== "cn") {
            this.getRiskScanTranslations(
              this.current_history_item.log_data,
              stringValues,
              stringKeys,
            ).then((res) => {
              this.total_loaded++;

              this.risk_search_complete = true;
              this.pdf_document.risk_info_data = this.risk_info_data;
            });
          } else {
            this.total_loaded++;

            this.risk_info_data = this.current_history_item.log_data.Result;
            this.pdf_document.risk_info_data = this.risk_info_data;
            this.risk_search_complete = true;
          }
          break;
        case "930":
          this.service_code_list = ["930"];

          if (!this.current_history_item.log_data.Result.Data) {
            this.no_result = true;
            this.total_loaded = 3;
            this.$bvModal.show("display_result");
            return;
          }
          this.total_loaded++;
          this.current_history_item.log_data.Result.Data.map((item) => {
            if (item.ProsecutorList.length > 0) {
              item.ProsecutorList = item.ProsecutorList.map((value) => {
                return value.Name;
              }).join(",");
            }

            if (item.DefendantList.length > 0) {
              item.DefendantList = item.DefendantList.map((value) => {
                return value.Name;
              }).join(",");
            }

            return item;
          });
          var tmp = {};
          tmp.Data = [];
          this.total_loaded++;
          this.formatArrayObjectTables(
            this.current_history_item.log_data.Result.Data,
            tmp.Data,
          ).then((res) => {
            this.court_search_complete = true;
            this.court_info_data.response_info = tmp;
            this.court_info_data.response_info.VerifyResult =
              this.current_history_item.log_data.Result.VerifyResult;
            this.pdf_document.court_info_data = this.court_info_data;
            this.total_loaded++;
          });
          break;
        case "701":
          this.service_code_list = ["701"];

          if (!this.current_history_item.log_data.Result) {
            this.no_result = true;
            this.total_loaded = 3;
            this.$bvModal.show("display_result");
            return;
          }
          this.total_loaded++;

          var tmp = [];
          this.total_loaded++;
          this.formatArrayObjectTables(
            this.current_history_item.log_data.Result,
            tmp,
          ).then((res) => {
            this.total_loaded++;
            this.news_info_data.response_info = tmp;
            this.news_search_complete = true;
            this.pdf_document.news_info_data = this.news_info_data;
          });

          break;
        case "886":
          this.service_code_list = ["886"];

          if (!this.current_history_item.log_data.Result) {
            this.no_result = true;
            this.total_loaded = 3;
            this.$bvModal.show("display_result");
            return;
          }
          this.total_loaded++;
          var result = this.current_history_item.log_data.Result;
          var tmp = [];
          this.total_loaded++;
          this.formatArrayObjectTables(
            this.current_history_item.log_data.Result,
            tmp,
          ).then((res) => {
            this.business_fuzzy_info.response_info = tmp;
            console.log("hist paging");
            console.log(this.current_history_item.log_data);
            this.business_fuzzy_info.Paging =
              this.current_history_item.log_data.Paging;

            this.enterprise_fuzzy_complete = true;
            this.pdf_document.business_fuzzy_info = this.business_fuzzy_info;

            this.total_loaded++;
          });
          break;
      }
      this.$bvModal.show("display_result");
    },

    //     async groupAnnualResults(results){
    //     await results.forEach(async result=>{
    //         if(Object.keys(this.annual_info_data).indexOf(result.BasicInfoData.RegNo)==-1){

    //             //add new company
    //             this.annual_info_data[result.BasicInfoData.RegNo] = {
    //                 'basic_info': result.BasicInfoData,
    //                 'results': [
    //                     result
    //                 ]
    //             }
    //             console.log('groupresults');
    //             console.log(this.annual_info_data);
    //         }else{
    //             //add result to existing company
    //             this.annual_info_data[result.BasicInfoData.RegNo].results.push(result)
    //             console.log('groupresults else');
    //             console.log(this.annual_info_data);
    //         }
    //     })
    // },
    /*async*/ groupAnnualResults(results) {
      console.log("group");
      console.log(results);
      return new Promise((resolve, reject) => {
        console.log("before");
        console.table(results);

        results = results.map((result) => {
          for (let key in result) {
            let data = result[key];
            if (typeof data !== "object") {
              console.log("string", data);
              result[key] = data;
            } else {
              console.warn(key);
              if (
                key == "BasicInfoData" ||
                key == "AssetsData" ||
                key == "SocialInsurance"
              ) {
                if (Array.isArray(data)) {
                  const data_ = {};
                  console.log("not string");
                  data.forEach((item) => {
                    console.log("item", item);
                    data_[item.Key] = item.Translated;
                  });
                  result[key] = data_;
                }
              } else {
                result[key] = data;
              }
            }
          }
          return result;
        });
        console.log("after");
        console.table(results);
        /*await*/ results.forEach(
          /*async*/(result) => {
            if (
              Object.keys(this.annual_info_data).indexOf(
                result.BasicInfoData.RegNo,
              ) == -1
            ) {
              //add new company
              this.annual_info_data[result.BasicInfoData.RegNo] = {
                basic_info: result.BasicInfoData,
                results: [result],
              };
              //console.log('groupresults');
              //console.log(this.annual_info_data);
            } else {
              //add result to existing company
              this.annual_info_data[result.BasicInfoData.RegNo].results.push(
                result,
              );
              //console.log('groupresults else');
              //console.log(this.annual_info_data);
            }
          },
        );
        resolve();
      });
    },
    initializeData() {
      this.total_loaded = 0;
      this.startTimer();
      this.no_result = false;
      this.service_code_list = [];

      this.court_info_data = { response_info: {} };
      this.news_info_data = { response_info: {} };
      this.business_fuzzy_info = { response_info: {} };
      this.company_info_data = {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      };
      this.search_company_info_complete = false;
      this.anual_search_complete = false;
      this.risk_search_complete = false;
      this.court_search_complete = false;
      this.news_search_complete = false;
      this.enterprise_fuzzy_complete = false;
    },
    translateText(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        axios
          .get(
            window.base +
            "/library/TranslateNext?text=" +
            text +
            "&source=zh&target=" +
            locale,
          )
          .then((response) => {
            return response.data.translation;
          });
      } else {
        return text;
      }
    },
    translateTextArray(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
          "/library/TranslateNextArray?source=zh&target=" +
          locale,
          text,
        );
      }
    },
    async formatObjects(object, list) {
      return this.translateTextArray(object).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          list[i].push(JSON.parse(res.data[i]).translation);
        }
        this.company_info_data.service_info = list;
      });
    },
    // formats table data with translations
    async formatObjectTablesCompany(object, list) {
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values)
          .then((res) => {
            res.data.forEach((t, i) => {
              if (
                keys[i] === "CreditCode" ||
                keys[i] === "No" ||
                keys[i] === "IndustryCode" ||
                keys[i] === "SubIndustryCode"
              )
                list.push({
                  Key: keys[i],
                  Translated: values[i],
                  Original: values[i],
                });
              else
                list.push({
                  Key: keys[i],
                  Translated: JSON.parse(t).translation,
                  Original: values[i],
                });
            });
          })
          .catch((e) => {
            console.log("catch formatObjectTables", e);
            console.log(object);
            return false;
          });
      } else return true;
    },
    async formatArrayObjectTables(object, list) {
      if (object.length > 0) {
        for (const obj of object) {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          await this.translateTextArray(values)
            .then((res) => {
              var translated = {};
              for (let j = 0; j < res.data.length; j++) {
                if (
                  keys[j] === "CreditCode" ||
                  keys[j] === "No" ||
                  keys[j] === "IndustryCode" ||
                  keys[j] === "SubIndustryCode"
                )
                  translated[keys[j]] = values[j];
                else translated[keys[j]] = JSON.parse(res.data[j]).translation;
              }
              list.push(translated);
            })
            .catch(() => {
              //console.log('catch formatArrayObjectTables')
              return false;
              //console.log('error translating...')
            });
        }
      } else return true;
    },
    async formatObjectTables(object, resObject) {
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values).then((res) => {
          res.data.forEach((t, i) => {
            if (
              keys[i] === "CreditCode" ||
              keys[i] === "No" ||
              keys[i] === "IndustryCode" ||
              keys[i] === "SubIndustryCode"
            )
              resObject[keys[i]] = values[i];
            else resObject[keys[i]] = JSON.parse(t).translation;
            //list.push({Key: keys[i], Translated: JSON.parse(t).translation, Original: values[i] })
          });
        });
      } else return true;
    },
    async formatArrayObjectTablesAnnual(object, list) {
      if (object.length > 0) {
        list = [];
        for (const obj of object) {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          await this.translateTextArray(values).then((res) => {
            var translated = {};
            for (let j = 0; j < res.data.length; j++) {
              if (
                keys[j] === "CreditCode" ||
                keys[j] === "No" ||
                keys[j] === "IndustryCode" ||
                keys[j] === "SubIndustryCode"
              )
                translated[keys[j]] = values[j];
              else translated[keys[j]] = JSON.parse(res.data[j]).translation;
            }
            list.push(translated);
          });
        }
        // return await Promise.all(object.map(async (obj) => {

        // }))
        // object.forEach((obj, i) => {
        //     var keys = Object.keys(obj);
        //     var values = Object.values(obj);
        //     return this.translateTextArray(values).then(res => {
        //         var translated = {};
        //         for (let j = 0; j < res.data.length; j++) {
        //             if (keys[j] === 'CreditCode' || keys[j] === 'No' || keys[j] ==='IndustryCode' || keys[j] === 'SubIndustryCode')
        //                 translated[keys[j]] = values[j];
        //             else
        //                 translated[keys[j]] = JSON.parse(res.data[j]).translation;
        //         }
        //         list.push(translated);

        //     })
        // })
      } else return true;
    },

    async formatStringValues(values, keys, object) {
      var locale = this.$i18n.locale;

      return this.translateTextArray(values).then((res) => {
        res.data.forEach((r, i) => {
          if (locale !== "cn") object[keys[i]] = JSON.parse(r).translation;
          else object[keys[i]] = values[i];
        });
      });
    },
    // async getCompanyInfoTranslations(service_to_translate, tmp_service_info, tmp_response_info) {
    //     console.log(service_to_translate, tmp_service_info, tmp_response_info)
    //         await Promise.all( [
    //         //Formating main result object properties
    //         this.formatObjects(service_to_translate, tmp_service_info),
    //         //Formating object tables data
    //         this.formatObjectTablesCompany(tmp_response_info.Area,this.company_info_data.areaList),
    //         this.formatObjectTablesCompany(tmp_response_info.Industry,this.company_info_data.industryList),
    //         this.formatObjectTablesCompany(tmp_response_info.RevokeInfo,this.company_info_data.revokeInfoList),
    //         this.formatObjectTablesCompany(tmp_response_info.ParentInfo,this.company_info_data.parentInfoList),
    //         //Formating object array tables
    //         this.formatArrayObjectTables(tmp_response_info.EntTagList, this.company_info_data.EntTagList),
    //         this.formatArrayObjectTables(tmp_response_info.ChangeList, this.company_info_data.ChangeList),
    //         this.formatArrayObjectTables(tmp_response_info.UsedNameList, this.company_info_data.UsedNameList),
    //         this.formatArrayObjectTables(tmp_response_info.ShareHolderList, this.company_info_data.ShareHolderList),
    //         this.formatArrayObjectTables(tmp_response_info.EmployeeList, this.company_info_data.EmployeeList),
    //         this.formatArrayObjectTables(tmp_response_info.InvestList, this.company_info_data.InvestList),
    //         this.formatArrayObjectTables(tmp_response_info.BranchList, this.company_info_data.BranchList),
    //         this.formatArrayObjectTables(tmp_response_info.MoreEmailList, this.company_info_data.MoreEmailList)

    //         ]);
    // },
    //     async getRiskScanTranslations(response, stringValues, stringKeys) {
    //     await Promise.all( [
    //         this.formatStringValues(stringValues, stringKeys, this.risk_info_data),
    //         this.formatObjectTables(response.data.Result.Industry,this.risk_info_data.Industry),
    //         this.formatObjectTables(response.data.Result.Area,this.risk_info_data.Area),
    //         this.formatObjectTables(response.data.Result.RevokeInfo,this.risk_info_data.RevokeInfo),
    //         this.formatObjectTables(response.data.Result.ContactInfo,this.risk_info_data.ContactInfo),
    //         this.formatArrayObjectTables(response.data.Result.Penalty, this.risk_info_data.Penalty),
    //         this.formatArrayObjectTables(response.data.Result.Exceptions, this.risk_info_data.Exceptions),
    //         this.formatArrayObjectTables(response.data.Result.ShiXinItems, this.risk_info_data.ShiXinItems),
    //         this.formatArrayObjectTables(response.data.Result.ZhiXingItems, this.risk_info_data.ZhiXingItems),
    //         this.formatArrayObjectTables(response.data.Result.MPledge, this.risk_info_data.MPledge),
    //         this.formatArrayObjectTables(response.data.Result.Pledge, this.risk_info_data.Pledge),
    //         this.formatArrayObjectTables(response.data.Result.SpotCheck, this.risk_info_data.SpotCheck),
    //         this.formatArrayObjectTables(response.data.Result.CompanyTaxCreditItems, this.risk_info_data.CompanyTaxCreditItems),
    //         this.formatArrayObjectTables(response.data.Result.CompanyProducts, this.risk_info_data.CompanyProducts),
    //         this.formatArrayObjectTables(response.data.Result.PermissionEciInfo, this.risk_info_data.PermissionEciInfo),
    //         this.formatArrayObjectTables(response.data.Result.PenaltyCreditChina, this.risk_info_data.PenaltyCreditChina),
    //         this.formatArrayObjectTables(response.data.Result.Partners, this.risk_info_data.Partners),
    //         this.formatArrayObjectTables(response.data.Result.Employees, this.risk_info_data.Employees),
    //         this.formatArrayObjectTables(response.data.Result.Branches, this.risk_info_data.Branches),
    //         this.formatArrayObjectTables(response.data.Result.ChangeRecords, this.risk_info_data.ChangeRecords),
    //         this.formatArrayObjectTables(response.data.Result.EmergingIndustyList, this.risk_info_data.EmergingIndusty),
    //         this.formatArrayObjectTables(response.data.Result.TagList, this.risk_info_data.TagList),
    //         this.formatArrayObjectTables(response.data.Result.ARContactList, this.risk_info_data.ARContactList),
    //         this.formatArrayObjectTables(response.data.Result.OriginalName, this.risk_info_data.OriginalName),

    //     ]);

    // },
    // async getAnnualTranslations(result) {
    //         await Promise.all(result.map(async (res) => {
    //             await this.formatObjectTables(res.BasicInfoData, res.BasicInfoData);
    //             await this.formatObjectTables(res.AssetsData, res.AssetsData);
    //             await this.formatObjectTables(res.SocialInsurance, res.SocialInsurance);
    //             await this.formatArrayObjectTablesAnnual(res.ChangeList, res.ChangeList);
    //             await this.formatArrayObjectTablesAnnual(res.InvestInfoList, res.InvestInfoList);
    //             await this.formatArrayObjectTablesAnnual(res.PartnerList, res.PartnerList);
    //             await this.formatArrayObjectTablesAnnual(res.ProvideAssuranceList, res.ProvideAssuranceList);
    //             await this.formatArrayObjectTablesAnnual(res.StockChangeList, res.StockChangeList);
    //             await this.formatArrayObjectTablesAnnual(res.WebSiteList, res.WebSiteList);
    //             await this.formatArrayObjectTablesAnnual(res.AdministrationLicenseList, res.AdministrationLicenseList);
    //             await this.formatArrayObjectTablesAnnual(res.BranchList, res.BranchList);
    //             await this.formatArrayObjectTablesAnnual(res.EmployeeList, res.EmployeeList);
    //             return true;
    //         }));
    //     },
    displayServicesName(code) {
      let codes = code.split(",");
      let services = [];
      codes.forEach((code_) => {
        this.service_codes.forEach((item) => {
          if (item.value == code_) {
            services.push(item.display_text);
          }
        });
      });
      return services.join(", ");
      // let service = this.service_codes[this.service_codes.findIndex(item=>item.value==code)]
      // if(service)
      //     return service.display_text
      // return ''
    },
    startTimer() {
      var sec = 0;
      this.interval = setInterval(() => {
        this.timer_seconds = this.pad(++sec % 60);
        this.timer_minutes = this.pad(parseInt(sec / 60, 10));
      }, 1000);
    },
    pad(val) {
      return val > 9 ? val : "0" + val;
    },
  },
  watch: {
    total_loaded: function (newVal, oldVal) {
      if (oldVal < 3 && newVal >= 3) {
        clearInterval(this.interval);
      }
    },
    page() {
      this.load();
    },
  },
};
</script>
<style>
@media (min-width: 992px) {
  .modal .modal-huge {
    max-width: 90% !important;
    width: 90% !important;
  }
}

#sia_progress-hist {
  width: 200px;
  height: 100px;
  margin: 20px auto;
  margin-bottom: 40px;
}

.pagination.b-pagination .page-item {
  box-shadow: none !important;
  width: 42px;
  height: 44px;

  /* attis/primary */

  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* primary100 */

  color: #ffffff;
}

.pagination.b-pagination .page-item.active {
  background: #04416d;
}

.page-item.disabled .page-link {
  background-color: transparent !important;
  border-color: transparent !important;
  width: 42px;
  height: 44px;

  /* attis/primary */

  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* primary100 */
  text-align: center;

  color: #ffffff;
}

.page-item .page-link {
  background: transparent !important;
  color: #04416d;
  width: 42px;
  height: 44px;
}

.page-item.active .page-link {
  background-color: transparent !important;
  border-color: transparent !important;
  width: 42px;
  height: 44px;

  /* attis/primary */

  background: #04416d;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* primary100 */

  color: #ffffff;
}

.btn-group .dropdown .btn {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>

<style scoped>
  @media (max-width: 768px) {
    .mobile-grade {
      font-size: 1rem;
    }
  }
</style>
